export default {
  translation: {
    // header
    SelectLanguage: "Dil Seç",
    Discover: "Keşfet",
    WhyQriend: "Neden QRiend?",
    LeaveMark: "İzini Bırak",
    InstallNow: "Hemen İndir",
    Login: "Giriş Yap",
    Register: "Kayıt Ol",
    LogOut: "Çıkış Yap",

    // footer
    HomePage: "Anasayfa",
    QriendDescFooter:
      "Sosyal ortamlarda yeni arkadaşlıklar keşfet, güvenli ve modern bir şekilde tanış!",
    Pages: "Sayfalar",
    PrivacyAndSecurity: "Gizlilik ve Güvenlik",
    HomePage: "Anasayfa",
    QriendTeam: "Ekibimiz",
    PrivacyPolicy: "Gizlilik Politikası",
    TermsOfUse: "Kullanım Koşulları",
    DataSecurity: "Veri Güvenliği",
    CookiePolicy: "Çerez Politikası",
    AccountSecurity: "Hesap Güvenliği",
    LegalConsentAndDisclosureText: "Yasal Rıza ve Aydınlatma Metni",
    ChildSafetyPolicy: "Çocuk Güvenliği Politikası",
    PrivacySettingsGuide: "Gizlilik Ayarları Politikası",
    SuitableForAllDevices: "Tüm Cihazlarla Uyumlu",
    DownloadNowFooter: "Şimdi İndir, Sosyal Ağını Genişlet!",

    // delete request
    DeleteRequestTitle: "Hesap Silme Talebi",
    DeleteAccountQuestion: "Hesabınızı Silmek İstiyor musunuz?",
    Username: "Kullanıcı Adı",
    Password: "Şifre",
    DeleteReason: "Hesabınızı neden silmek istiyorsunuz?",
    UsernamePlaceholder: "Kullanıcı adınızı girin",
    PasswordPlaceholder: "Şifrenizi girin",
    ReasonPlaceholder: "Hesabınızı silme nedeninizi açıklayın...",
    SubmitDeleteRequest: "Hesap Silme Talebi Gönder",
    Warning: "Dikkat",
    WarningMessage: "Hesap silme işlemi geri alınamaz. Tüm verileriniz kalıcı olarak silinecektir.",
    RequestSubmittedSuccessfully: "Talep Başarıyla Gönderildi",
    RequestSubmittedMessage: "Hesap silme talebiniz alınmıştır. En kısa sürede size geri dönüş yapılacaktır.",
    SendNewRequest: "Yeni Talep Gönder",
    UsernameRequired: "Kullanıcı adı gereklidir",
    PasswordRequired: "Şifre gereklidir",
    ReasonRequired: "Hesap silme nedeni gereklidir",

    // register page
    createAccount: "Hesap Oluştur",
    createAccountDesc: "Hemen kayıt ol ve yeni insanlarla tanışmaya başla!",
    firstname: "Ad",
    lastname: "Soyad",
    username: "Kullanıcı Adı",
    email: "E-posta",
    password: "Şifre",
    gender: "Cinsiyet",
    male: "Erkek",
    female: "Kadın",
    noGender: "Belirtmek İstemiyorum",
    registerMain: "Kayıt Ol",
    registerDesc: "Zaten hesabınız var mı?",
    registerLogin: "Giriş Yap",
    kvkkConsent: "KVKK ve Gizlilik Sözleşmesini onaylıyorum.",
    kvkkConsentRequired: "KVKK ve Gizlilik Sözleşmesini onaylamanız gereklidir.",
    privacyPolicy: "Gizlilik Politikası",
    termsOfUse: "Kullanım Koşulları",

    // Landing Qriend Nedir?
    WhatIsQriend: "QRiend Nedir?",
    WhatIsQriendDesc:
      "QR kod teknolojisi ile aynı mekanda bulunan insanlarla tanışmanızı sağlar. Bar, kafe, restoran gibi sosyal alanlarda yeni insanlarla tanışmak için modern ve güvenli bir platform sunar.",
    RealProfile: "Gerçek Profil",
    RealProfileDesc:
      "Sadece doğrulanmış gerçek kullanıcılarla etkileşim kurarsınız.",
    InstantMeetingOpportunity: "Anlık Tanışma İmkanı",
    InstantMeetingOpportunityDesc:
      "Mekanda gördüğünüz biriyle anında mesajlaşarak tanışabilirsiniz.",
    VenueChats: "Mekan Sohbetleri",
    VenueChatsDesc:
      "QRiend, bulunduğunuz mekanda dijital sosyalleşme imkânı sunar.",

    // Landing Nasıl Tanışılır?
    HowtoMeet: "Nasıl Tanışılır?",
    HowtoMeetDesc:
      "Uygulamamız sayesinde, bulunduğunuz mekandaki insanlarla gerçek zamanlı olarak tanışmak artık çok kolay! İşte adım adım nasıl kullanacağınız;",
    EntryandConnectiontotheSpace: "Mekanla Giriş ve Bağlantı",
    EntryandConnectiontotheSpaceDesc: "QR kodu telefonunuzla tarayın",
    EntryandConnectiontotheSpaceDesc2:
      "Uygulamaya giriş yaparak mekandaki ağa katılın",
    InSituExploration: "Mekan İçi Keşif",
    InSituExplorationDesc: "O anda mekanda bulunan diğer kullanıcıları görün",
    InSituExplorationDesc2: "Size ilginç gelen profilleri inceleyin",
    CommunicationInitiation: "İletişim Başlatma",
    CommunicationInitiationDesc: "Dikkatinizi çeken kişilere mesaj gönderin",
    CommunicationInitiationDesc2:
      "Göz göze geldiğiniz biriyle kolayca iletişime geçin",
    CommunicationInitiationDesc3: "Bulunduğunuz yerin toplu chat alanına girin",
    SafeSocialization: "Güvenli Sosyalleşme",
    SafeSocializationDesc: "Karşılıklı mesajlaşarak tanışın",
    SafeSocializationDesc2:
      "İstediğiniz zaman sohbeti kontrol edebilir veya sonlandırabilirsiniz",
    SafeSocializationDesc3:
      "Yeni insanlarla tanışmaya keyifli ve güvenli bir şekilde devam edin",

    //   Uygulamayı İndir Bölümü
    DownloadApp: "UYGULAMAYI İNDİR &",
    DownloadApp2: "KEŞFETMEYE BAŞLA!",
    DownloadAppDesc: "App Store ve Google Play'de!",
    DownloadAppDesc2: "Ücretsiz indir,",
    DownloadAppDesc3: "premium özellikleri keşfet.",

    // discover
    DiscoverTitle:
      "Gerçek Buluşmaları Kolaylaştıran Yenilikçi ve Sosyal Platform",
    DiscoverDesc:
      "Sıkıldınız mı sonu gelmeyen mesajlaşmalardan? Gerçek hayatta tanışmak istediğiniz insanlarla aynı mekanda olduğunuzu bilmek istemez miydiniz? İşte tam da bu yüzden bizim uygulamamız farklı!",
    DiscoverEp2:
      "Partner mekanlarımızda QR kod teknolojisiyle varlığınızı doğrulayarak, aynı mekanda bulunan gerçek insanlarla tanışma fırsatı yakalamaya hazır mısınız?",
    DiscoverEp2Dot: "Arkadaşlık Takibi",
    DiscoverEp2DotDesc:
      "Beğendiğiniz profilleri takip ederek onların tercih ettiği mekanları keşfedin. Yeni yerler ve yeni insanlarla tanışma fırsatını yakalayın.",
    DiscoverEp3Dot: "Profil ve Mekan Beğenisi",
    DiscoverEp3DotDesc:
      "Beğendiğiniz profiller ve mekanlar üzerinden yeni insanlarla tanışın ve favori mekanlarınızı keşfedin.",
    DiscoverEp4Dot: "Mekanda Tanışma",
    DiscoverEp4DotDesc:
      "Sıradan tanışma uygulamalarının aksine, bizde her şey gerçek! Beğendiğiniz biriyle aynı mekanda olduğunuzu görebilir ve hemen tanışabilirsiniz.",
    SwiperText: "Kullanışlı Arayüz",

    SafetyMeet: "Daha Güvenli ve Eğlenceli Tanışmalar",
    RealTimeInteraction: "Gerçek Zamanlı Etkileşim",
    RealTimeInteractionDesc:
      "Sanal dünyada kaybolmak yerine, gerçekten şu anda aynı mekanda olan insanlarla tanışın",
    RealTimeInteractionDesc2:
      "Favori kafenizde kim var? Anında görün ve tanışma fırsatını kaçırmayın",
    RealTimeInteractionDesc3:
      "QR kod teknolojimiz sayesinde, bulunduğunuz mekanı kolayca doğrulayın",
    SecureAndVerifiedEnvironment: "Güvenli ve Doğrulanmış Ortam",
    SecureAndVerifiedEnvironmentDesc: "Partner mekanlarımızda sosyalleşin",
    SecureAndVerifiedEnvironmentDesc2:
      "Gerçek konum doğrulaması ile sahte profil riski minimumda",
    SecureAndVerifiedEnvironmentDesc3:
      "Favori mekanlarınızı keşfedin ve paylaşın",
    BenefitsForBusinesses: "İşletmeler İçin Avantajlar",
    BenefitsForBusinessesDesc: "Müşteri trafiğinizi artırın",
    BenefitsForBusinessesDesc2: "Sosyal etkileşimi yüksek bir ortam yaratın",

    // leave-mark
    LeaveMark: "İzini Bırak",
    LeaveMarkTitle:
      "İzini Bırak: Sosyal Deneyiminizi Genişletin Etkinliklerde Bağlantılar Kurun",
    LeaveMarkDesc:
      "QRiend'in 'İzini Bırak' özelliği, sosyal deneyiminizi konserler, festivaller, konferanslar ve daha birçok etkinlikte genişletmenizi sağlar. Artık sadece mekanlarda değil, katıldığınız her etkinlikte yeni insanlarla tanışabilirsiniz.",
    How2Use: "Nasıl Çalışır?",
    How2UseDot1: "Etkinliğe Katılın",
    How2UseDot1Desc:
      "Konser, festival, konferans veya herhangi bir etkinliğe gidin",
    How2UseDot1Desc2: "Etkinlik alanındaki özel QRiend QR kodunu taratın",
    How2UseDot1Desc3: "Anında etkinlik chat'ine bağlanın",
    How2UseDot2: "Etkinlik Katılımcılarını Keşfedin",
    How2UseDot2Desc:
      "Aynı etkinliğe katılan diğer QRiend kullanıcılarını görüntüleyin",
    How2UseDot2Desc2:
      "Etkinlik chat'inde kaç kişinin aktif olduğunu anlık olarak takip edin",
    How2UseDot2Desc3: "Ortak ilgi alanlarına sahip olduğunuz kişileri bulun",
    How2UseDot3: "Özel Etkileşimler",
    How2UseDot3Desc:
      "Dikkatinizi çeken katılımcılara özel emoji gönderebilirsiniz",
    How2UseDot3Desc2:
      "Gönderilen emojiler 'Kullanıcı A, Kullanıcı B'ye kalp emojisi gönderdi' şeklinde tüm chat'te görünür",
    How2UseDot3Desc3:
      "Emoji gönderimi premium bir özelliktir ve etkinliklerde tanışmayı daha eğlenceli hale getirir",
    WhereCanIUseIt: " Nerelerde Kullanabilirim?",
    WhereCanIUseItDesc:
      "Kafelerden konserlere, festivallerden restoranlara kadar farklı ortamlarda yeni insanlarla tanışmanın en kolay yolu.",
    WhereCanIUseItDot1: "Konserlerde İzini Bırak",
    WhereCanIUseItDot1Desc:
      "Katıldığınız konserde sizde izinizi bırakacak bir şeyler yazın.",
    WhereCanIUseItDot2: "Kafelerde İzini Bırak",
    WhereCanIUseItDot2Desc:
      "Kafe veya publarda geniş arkadaş ortamlarında sosyalleşme imkanı",
    WhereCanIUseItDot3: "Barlar ve Gece Kulüplerinde Kullanım",
    WhereCanIUseItDot3Desc:
      "Gece hayatında sosyalleşme, tema geceleri ve güvenli tanışma imkanları",
    DownloadApp: "Mobil Uygulamayı İndirerek İzini Bırak",

    // downloadPage
    DownloadNowNew: "Hemen İndirin ve Yeni",
    DownloadNowNew2: "İnsanlarla Tanışmaya",
    DownloadNowNew3: "Başlayın!",
    DownloadNowDesc:
      "Gittiğin her mekânda, sadece bir QR ile yeni insanlarla tanış!",
    SupportPlatforms: "Desteklenen Platformlar ve Cihazlar",
    SupportPlatformsDesc: "Her Yerden Erişim İmkanı",
    SupportPlatformsDesc2: "Mobil Cihazlar",
    SupportPlatformsDescDot:
      "iOS uygulaması (iPhone ve iPad için optimize edilmiş)",
    SupportPlatformsDescDot2:
      "Android uygulaması (Tüm Android telefonlar ve tabletler)",

    // login ve register
    welcome: "Hoş Geldin",
    welcomeDesc:
      "Sizi özledik! Kaçırdıklarınızı yakalamak için lütfen oturum açın.",
    email: "E-Mail",
    password: "Şifre",
    forgotPassword: "Şifreni mi unuttun?",
    login: "Giriş Yap",
    registerMain: " Kayıt Ol",
    loginDesc: "Henüz bir hesabınız yok mu? Hemen",
    loginReg: "kayıt ol",
    createAccount: "Hesap Oluştur",
    createAccountDesc: "Hemen kaydolun, yeni arkadaşlıklar kurmaya başlayın.",
    firstname: "Ad",
    lastname: "Soyad",
    username: "Kullanıcı Adı",
    gender: "Cinsiyet",
    password: "Şifre (En az 6 karakter)",
    register: "Kayıt Ol",
    registerDesc: "Hesabınız var mı? Hemen",
    registerLogin: "Giriş Yapın",
    rememberMe: "Beni Hatırla",
    male: "Erkek",
    female: "Kadın",
    noGender: "Cinsiyet Belirtmek İstemiyorum",

    // Şifre Sıfırlama - forgotPassword.js
    resetPassword: "Şifreni Yenile",
    resetPasswordDesc:
      "Şifre sıfırlama talebinde bulunmak için lütfen e-posta adresinizi giriniz.",
    emailPlaceholder: "...@qriend.app",
    sending: "Gönderiliyor...",
    send: "Gönder",
    userNotFoundError: "Bu e-posta adresi ile kayıtlı kullanıcı bulunamadı.",
    generalError: "Bir hata oluştu, lütfen tekrar deneyin.",
    checkSpamFolder: "*Spam klasörünüzü kontrol etmeyi unutmayın.",

    // Şifre Sıfırlama Onay - forgotPasswordConfirm.js
    passwordReset: "Şifre Sıfırlama",
    passwordResetDesc:
      "Mail adresinize gelen 6 haneli kodu girin ve yeni şifrenizi oluşturun.",
    verificationCode: "Doğrulama Kodu",
    codeValidityTime: "Kodun geçerlilik süresi",
    newPassword: "Yeni Şifre",
    newPasswordPlaceholder: "Yeni şifrenizi giriniz",
    confirmPassword: "Şifre Onayı",
    confirmPasswordPlaceholder: "Şifrenizi onaylayınız",
    resettingPassword: "Şifre Sıfırlanıyor...",
    resetPasswordButton: "Şifreyi Sıfırla",
    enterVerificationCode: "6 haneli doğrulama kodunu giriniz.",
    passwordMinLength: "Şifre en az 6 karakter olmalı.",
    passwordMismatch: "Şifreler uyuşmuyor!",
    passwordResetSuccess: "Şifreniz başarıyla sıfırlandı!",
    passwordResetError: "Şifre sıfırlanamadı, lütfen tekrar deneyin.",

    // contact page
    ContactTitle: "İletişim",
    ContactSubtitle: "Sorularınız veya geri bildiriminiz için formu doldurun.",
    ContactName: "Ad Soyad",
    ContactEmail: "E‑posta",
    ContactMessage: "Mesajınız",
    ContactNamePlaceholder: "Adınızı ve soyadınızı girin",
    ContactEmailPlaceholder: "ornek@mail.com",
    ContactMessagePlaceholder: "Mesajınızı yazın",
    ContactSend: "Gönder",
    ContactSending: "Gönderiliyor...",
    ContactSuccess: "Form başarıyla gönderildi.",
    ContactError: "Bir hata oluştu. Lütfen tekrar deneyin.",
  },
};
